import { menuSearchInputMobileStateSelector } from '../../../reducers/menu';

export const MENU_SEARCH_INPUT_MOBILE_STATE = 'MENU_SEARCH_INPUT_MOBILE_STATE';

export function menuSearchInputMobileStateChange() {
    return (dispatch, getState) => {
        dispatch({
            type: MENU_SEARCH_INPUT_MOBILE_STATE,
            payload: !menuSearchInputMobileStateSelector(getState()),
        });
    };
}
